export default __webpack_public_path__ + "static/media/visao.6899c589.svg";